<template>
  <a
    class="al-link"
    test-id="al-link"
    :href="href"
    :class="{
      'is-small': isSmall,
      'has-icon': hasIcon,
      'is-disabled': isDisabled
    }"
    :aria-disabled="isDisabled"
    v-on="{ click: to !== null ? nuxtGoTo : emitClick }"
  >
    <span class="al-link_description">
      <!--
        @slot Use this slot for showing content inside link.
      -->
      <slot />
    </span>
    <!-- Icon -->
    <al-icon v-if="hasIcon" :name="hasIcon" class="al-button_icon al-icon" />
  </a>
</template>

<script>
import AlIcon from '../inline/icon/AlIcon.vue';

/**
 * Generic link by almendra component system, which have 5 variation (WIP)
 * **basic**, **primary**, **Secondary**, **light**, **dark**.
 * @displayName al-link
 */

export default {
  name: 'AlLink',
  components: {
    AlIcon
  },
  props: {
    /**
     * Link to redirect when user clicks
     * @values URL enconde string
     */
    href: {
      type: String,
      default: null
    },
    /**
     * Boolean flag to make link smaller
     * @values true, false
     */
    isSmall: {
      type: Boolean,
      default: false
    },
    /**
     * CSS class to render an icon next to the link
     * @values css selector
     */
    hasIcon: {
      type: String,
      default: null
    },
    /**
     * Link to page in a nuxt context.
     * @values URL encode string
     */
    to: {
      type: String,
      default: null
    },
    /**
     * Boolean flag to set disable state.
     * @values true, false
     */
    isDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Boolean flag to open link in a new tab.
     * @values true, false
     */
    isExternal: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    nuxtGoTo() {
      this.$emit('clickDone');
      if (this.isExternal) {
        window.open(this.to);
      } else {
        this.$router.push(this.to);
      }
    },
    emitClick() {
      /**
       * Event emitting for catch when developer need to execute a function on parent component.
       */
      this.$emit('clickDone');
    }
  }
};
</script>

<style lang="scss" scoped>
// -------------------------------------------------
// + Anchor General Styles
// -------------------------------------------------

a.al-link {
  color: color(green, darken, 1);
  cursor: pointer;
  font-family: font-family(text);
  font-size: font-size(base);
  font-weight: initial;
  line-height: line-height(base);
  text-decoration: none;
  transition: transition(fast);

  span.al-link_description {
    text-decoration: none;
  }

  // + Modifiers
  &.is-small {
    font-size: font-size(s);
  }

  &.has-icon {
    align-items: center;
    display: flex;
  }

  &.is-disabled {
    color: color(white, darken, 2);
    pointer-events: none;
  }

  // + States
  &:hover {
    color: color(green, darken, 2);

    span.al-link_description {
      text-decoration: underline;
    }
  }

  &:active {
    color: color(green, lighten, 1);

    span.al-link_description {
      text-decoration: underline;
    }
  }
}
</style>
